import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import logoImg from "../../../static/images/logow.png";
import Divider from "@material-ui/core/Divider";

// core components
import styles from "./styles/headerStyle.jsx";
import { Link } from "react-router-dom";

import { langDict, langAbbr } from "../../langConfig";

const useStyles = makeStyles(styles);

export default function Header(props) {
  const classes = useStyles();

  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });

  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, fixed, absolute } = props;

  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed,
  });

  return (
    <AppBar className={appBarClasses}>
      <Toolbar className={classes.container}>
        {localStorage.getItem("lang") === "0" ? (
          <React.Fragment>
            <a href={process.env.REACT_APP_INDEXPAGE}>
              <img src={logoImg} style={{ height: "40px" }} alt="logo"></img>{" "}
              &nbsp; &nbsp;
            </a>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <a href={process.env.REACT_APP_INDEXPAGE}>
              <img src={logoImg} style={{ height: "40px" }} alt="logo"></img>{" "}
              &nbsp; &nbsp;
            </a>
          </React.Fragment>
        )}

        {/* <SimpleMenu /> */}
      </Toolbar>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white",
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark",
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark",
    ]).isRequired,
  }),
};

function SimpleMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLang = (n) => {
    // console.log(n);
    localStorage.setItem("lang", n);
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{
          position: "absolute",
          top: "50%",
          left: "100%",
          transform: "translate(-100%, -50%)",
          color: "white",
        }}
      >
        {langAbbr[localStorage.getItem("lang")]}&nbsp;▼
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {langDict.slice(1).map((item, index) => {
          return (
            <Link to={`/?lang=${langAbbr[index]}`} style={{ color: "black" }}>
              <MenuItem onClick={changeLang.bind(this, index)}>
                {item}({langAbbr[index].toUpperCase()})
              </MenuItem>
            </Link>
          );
        })}

        {/*
              <Divider light />
              <a href="https://github.com/ChainCastle/Multilingual-MoveCastle" target="_blank" rel="noopener noreferrer" style={{color:"black"}}>
                <MenuItem onClick={handleClose}>
                    Contribution
                </MenuItem>
              </a>
              */}
      </Menu>
    </div>
  );
}
